import { merge } from 'lodash';
import { useMemo } from 'react';

import { adaptCssVariablesToThemeOverride } from '@savgroup-front-common/core/theme/adapters/adaptCssVariablesToThemeOverride';
import { applyThemeToCSSVariables } from '@savgroup-front-common/core/theme/applyThemeToCSSVariables';
import { Theme } from '@savgroup-front-common/types';

interface UseBridgedSellerThemeArgs {
  theme?: Theme;
}

/**
 * Closes the theming indirection loop for styled-components: the seller theme is
 * written into the `--brand-*` CSS variables, then read back through the adapter
 * so the styled theme sources its brand colors from the exact same CSS variables
 * as the Tailwind design system.
 *
 * Write and read must stay in the same synchronous pass (hence a single memo):
 * reading before the write would drop the seller override on the first render.
 */
const useBridgedSellerTheme = ({ theme }: UseBridgedSellerThemeArgs) => {
  return useMemo(() => {
    applyThemeToCSSVariables(theme);

    const brandThemeOverride = adaptCssVariablesToThemeOverride();

    return merge({}, theme, brandThemeOverride);
  }, [theme]);
};

export default useBridgedSellerTheme;
